import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var MonitorOutlineSVG = function MonitorOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M28,4H4A2,2,0,0,0,2,6V21a2,2,0,0,0,2,2h9v3H10a1,1,0,0,0,0,2H22a1,1,0,0,0,0-2H19V23h9a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V17H4V6ZM4,21V19H28v2Z"
  }));
};
MonitorOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MonitorOutlineSVG);